import React from 'react';
import { Link } from 'react-router-dom';
import { company } from '../data/companyData';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__top-inner">
          <div className="footer__brand">
            <div className="footer__logo">
              <img
                src="/logo-icon-white.png"
                alt="PrimeFix icon"
                className="footer__logo-icon-img"
              />
              <div className="footer__logo-wordmark">
                <div className="footer__logo-brand">
                  <span className="footer__logo-prime">PRIME</span><span className="footer__logo-fix">FIX</span>
                </div>
                <div className="footer__logo-sub">— SOLUTIONS LIMITED —</div>
                <div className="footer__logo-tagline">RELIABLE SOLUTIONS. EXCEPTIONAL SERVICE.</div>
              </div>
            </div>
            <p className="footer__tagline">{company.tagline}</p>
            <p className="footer__desc">
              Delivering integrated operations &amp; maintenance services across
              New Zealand since {company.established}.
            </p>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Services</h4>
            <ul className="footer__list">
              <li><Link to="/services?service=mep">MEP Systems</Link></li>
              <li><Link to="/services?service=hvac">HVAC & Cooling</Link></li>
              <li><Link to="/services?service=civil">Civil & Architectural</Link></li>
              <li><Link to="/services?service=fire">Fire Safety</Link></li>
              <li><Link to="/services?service=ifm">Facility Management</Link></li>
              <li><Link to="/services?service=preventive">Preventive & Corrective</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Company</h4>
            <ul className="footer__list">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Contact</h4>
            <ul className="footer__list footer__contact">
              <li>
                <span className="footer__contact-icon">📍</span>
                {company.address}
              </li>
              <li>
                <span className="footer__contact-icon">📞</span>
                <a href={`tel:${company.phone.replace(/\s+/g, '')}`}>{company.phone}</a>
              </li>
              <li>
                <span className="footer__contact-icon">✉️</span>
                <a href={`mailto:${company.email}`}>{company.email}</a>
              </li>
              <li>
                <span className="footer__contact-icon">🌐</span>
                <a href={`https://${company.website}`} target="_blank" rel="noopener noreferrer">{company.website}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© {new Date().getFullYear()} PrimeFix Solutions Limited. All rights reserved.</p>
          <p>Established {company.established} · {company.address}</p>
        </div>
      </div>
    </footer>
  );
}
